<template>
  <div>
    <transition name="slide">
      <div v-if="openPreview" class="newJD-slide-container">
        <div>
          <div class="d-flex align-items-center justify-content-between p-3">
            <div class="position-absolute pointer newJD-backArrow">
              <img
                @click="$emit('close-review-cand')"
                src="../../assets/img/accessconnew/boxBackArrow.svg"
                alt
              />
            </div>
            <div v-if="isPending" class="newJD-heading ml-3 pt-1">
              Review Candidate
            </div>
            <div v-else class="newJD-heading ml-3 pt-1">Preview Candidate</div>
            <div class="rotate-on-hover pointer">
              <img
                v-b-tooltip.hover.top="'Close'"
                @click="$emit('close-review-cand')"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
          <hr class="mb-0 mt-0" />
          <div
            class="d-flex w-100"
            :class="
              isPending || showBuilderProfile
                ? 'newJD-overflow'
                : 'newJD-preview-overflow'
            "
          >
            <div class="pr-3" style="width: 40%">
              <div class="newJD-left-container">
                <div>
                  <div class="newJD-head">Basic Details</div>
                  <!-- put for loop -->
                  <div
                    :class="
                      isPending || showBuilderProfile
                        ? 'newJD-left-inner-container'
                        : 'newJD-left-inner-container-preview'
                    "
                  >
                    <div
                      v-for="(field, i) in customFieldsArray"
                      :key="field.key + i"
                    >
                      <div
                        v-if="field.label !== 'Resume'"
                        class="w-100 d-flex align-items-center"
                        :class="i !== 0 ? 'mt-3' : ''"
                      >
                        <div class="newCand-basic-head" style="width: 40%">
                          {{ field.label }}
                        </div>
                        <div class="newCand-basic-content" style="width: 60%">
                          <div v-if="checkFieldKeys(field)">-</div>
                          <div
                            style="word-break: keep-all"
                            v-else-if="Object.keys(profileInfo).length > 0"
                          >
                            <template v-if="isHtmlContent(field)">
                              <div v-html="checkValuesOfKey(field)"></div>
                            </template>
                            <template v-else>
                              {{ checkValuesOfKey(field) }}
                            </template>
                            <template
                              v-if="
                                !checkFieldKeys(field) &&
                                field.label == 'Profile Image'
                              "
                            >
                              <img
                                @click="downloadFile(field)"
                                class="pointer ml-2"
                                src="../../assets/talentpool/tp_download_vc.svg"
                                alt=""
                              />
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="newJD-right-container relativeclass">
              <div class="newInt-control-tabs">
                <b-tabs v-model="tabIndex">
                  <b-tab title="Job Details" class="pr-1">
                    <div
                      :class="
                        isPending || showBuilderProfile
                          ? 'newJD-right-innerContent'
                          : 'newJD-right-innerContent-preview'
                      "
                    >
                      <div>
                        <span class="newJD-right-Intfont"
                          >Interview Process:
                        </span>
                        <span class="newJD-right-Intfont-subHead wordbreak">{{
                          profileInfo.interviewProcessName
                        }}</span>
                      </div>

                      <div class="mt-2 newCand-JD-container">
                        <div>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                              w-100
                            "
                          >
                            <div class="newCand-JD-container-head">
                              Job Name:
                            </div>
                            <div class="newCand-JD-container-createdOn-font">
                              Created On:
                              {{ profileInfo.createdAt | formatDate }}
                            </div>
                          </div>
                          <div
                            class="wordbreak newCand-JD-container-subhead mt-1"
                          >
                            {{ profileInfo.jobTitle }}
                          </div>
                        </div>

                        <div class="mt-4">
                          <div class="newCand-JD-container-head">
                            Recruiter Name:
                          </div>
                          <div class="newCand-JD-container-subhead mt-1">
                            {{ profileInfo.movedBy }}
                          </div>
                        </div>
                      </div>

                      <div class="mt-2 newCand-JD-container">
                        <div class="newCand-hist-font">History</div>
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            w-100
                            mt-4
                          "
                          v-for="(job, index) in particularJob.interviewProcess"
                          :key="index"
                        >
                          <div class="d-flex align-items-center">
                            <div>
                              <img
                                v-if="job.type == 'assesment' && job.completed"
                                src="../../assets/newJD/newCand-assessment-icon.svg"
                                alt=""
                              />
                              <img
                                v-else-if="
                                  job.type == 'assesment' && !job.completed
                                "
                                src="../../assets/newJD/disabled-newCand-assess-icon.svg"
                                alt=""
                              />
                              <img
                                v-else-if="job.type == 'f2f' && job.completed"
                                src="../../assets/newJD/newCand-f2f-icon.svg"
                                alt=""
                              />
                              <img
                                v-else-if="job.type == 'f2f' && !job.completed"
                                src="../../assets/newJD/disabled-newCand-f2f-icon.svg"
                                alt=""
                              />
                            </div>
                            <div class="ml-3">
                              <div
                                :class="
                                  !job.completed
                                    ? 'newCand-JD-container-head-disabled'
                                    : 'newCand-JD-container-head'
                                "
                              >
                                Round {{ index + 1 }} -
                                {{
                                  job.type == "assesment"
                                    ? "Assesment"
                                    : "Face to Face"
                                }}
                              </div>
                              <div
                                class="wordbreak mt-1"
                                :class="
                                  !job.completed
                                    ? 'newCand-JD-container-subhead-disabled'
                                    : 'newCand-JD-container-subhead'
                                "
                              >
                                {{ job.name }}
                              </div>
                            </div>
                          </div>

                          <div
                            @click="openFeedbackForm(job)"
                            v-if="job.completed"
                            class="pointer"
                          >
                            <img
                              src="../../assets/img/accessconnew/blueEye.svg"
                              alt="/"
                              class="pointer"
                            />
                            <span class="ml-2 newJD-selected-view-font">
                              Feedback Form
                              {{
                                job.feedback.length > 1
                                  ? ": " + job.feedback.length
                                  : ""
                              }}
                            </span>
                          </div>
                          <div
                            v-else-if="
                              job.completed &&
                              job.feedback.length == 1 &&
                              job.feedback[0].feedBackForm &&
                              (job.feedback[0].feedBackForm.customFeedback ==
                                undefined ||
                                (Object.keys(
                                  job.feedback[0].feedBackForm.customFeedback
                                ).length == 0 &&
                                  job.feedback[0].feedBackForm
                                    .panelFeedbackForm))
                            "
                            @click="
                              downloadFeedback(
                                job.feedback[0].feedBackForm.panelFeedbackForm
                              )
                            "
                            class="pointer"
                          >
                            <img
                              src="../../assets/talentpool/tp_download_vc.svg"
                              alt="/"
                              class="pointer"
                            />
                            <span class="ml-2 newJD-selected-view-font">
                              Feedback Form
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Resume" class="pr-1">
                    <div
                      :class="
                        isPending
                          ? 'newJD-allocate-overflow-resume'
                          : 'newJD-resume-overflow'
                      "
                    >
                      <!-- if word format -->
                      <div
                        v-if="isDocType(profileInfo.resume)"
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                      >
                        <div class="newCand-word-resume">
                          <div class="text-center">
                            <img
                              src="../../assets/newJD/newCand-word-doc.svg"
                              alt=""
                            />
                          </div>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                              mt-2
                            "
                          >
                            <div
                              class="newCand-word-resume-font text-truncate"
                              style="width: 85%"
                            >
                              {{
                                getFileName(
                                  profileInfo.resume
                                    .substring(
                                      profileInfo.resume.lastIndexOf("/") + 1
                                    )
                                    .split("?")[0]
                                    .replace(/%20/g, " ")
                                )
                              }}
                            </div>
                            <div>
                              <img
                                class="mr-2"
                                src="../../assets/newJD/newCand-line-icon.svg"
                                alt=""
                              />

                              <img
                                class="pointer"
                                src="../../assets/newJD/newCand-download-icon.svg"
                                alt=""
                                @click="downloadFeedback(profileInfo.resume)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- if pdf format -->
                      <div v-else class="h-100">
                        <div
                          :style="
                            isPending
                              ? 'height: calc(100vh - 350px);'
                              : 'height: calc(100vh - 287px)'
                          "
                          class="w-100 text-center"
                        >
                          <div class="h-100">
                            <pdf
                              class="h-100 w-100 check-pdf-class"
                              ref="pdf"
                              :src="profileInfo.resume"
                              :page="currentPage"
                              @num-pages="numPages = $event"
                              @link-clicked="handlePageLoaded"
                              @page-loaded="handlePageLoaded"
                            ></pdf>
                          </div>
                        </div>
                        <div
                          v-if="
                            profileInfo.resume != null &&
                            !isDocType(profileInfo.resume)
                          "
                          class="
                            viewResume-paginaTion-modal
                            align-items-center
                            justify-content-center
                            d-flex
                            w-100
                          "
                        >
                          <div class="pagination">
                            <b-pagination
                              align="center"
                              first-number
                              last-number
                              v-model="currentPage"
                              :total-rows="numPages"
                              :per-page="perPage"
                            >
                              <template #prev-text>
                                <span>
                                  <img
                                    src="../../assets/img/accessconnew/pageleft.svg"
                                    alt
                                  />
                                </span>
                              </template>
                              <template #next-text>
                                <span>
                                  <img
                                    src="../../assets/img/accessconnew/pageright.svg"
                                    alt
                                  />
                                </span>
                              </template>
                            </b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab v-if="!isPending" title="Remarks" class="pr-1">
                    <div class="p-3 newJD-allocate-overflow">
                      <div class="newJD-history-container">
                        <div
                          v-for="(history, i) in profileInfo.remarks"
                          :key="i"
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            w-100
                            h-100
                          "
                        >
                          <div class="d-flex w-100 h-100 relativeclass">
                            <div style="width: 5%">
                              <div class="newJD-lock-box-image">
                                <img
                                  class="d-flex"
                                  src="../../assets/New-imgs/interviewProcess-icons/newInt-round-circle.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                v-if="i != profileInfo.remarks.length - 1"
                                class="newJD-lock-box"
                              ></div>
                            </div>

                            <div
                              class="d-flex"
                              style="width: 95%"
                              :class="i !== 0 ? 'mt-3' : 'mt-0'"
                            >
                              <div
                                class="
                                  newJD-allocate-pic
                                  d-flex
                                  align-items-center
                                  justify-content-center
                                "
                                style="width: 43px"
                              >
                                {{ history.userIcon }}
                              </div>
                              <div class="ml-2" style="width: 92%">
                                <div
                                  class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    w-100
                                  "
                                >
                                  <div class="newJD-history-head">
                                    {{ history.userName }}
                                  </div>
                                  <div
                                    class="newJD-accepted-font"
                                    v-if="
                                      history.status && history.status == '1'
                                    "
                                  >
                                    Accepted
                                  </div>
                                  <div
                                    class="newJD-rejected-font"
                                    v-if="
                                      history.status && history.status == '2'
                                    "
                                  >
                                    Rejected
                                  </div>
                                </div>
                                <div
                                  class="newJD-history-subhead wordbreak mt-1"
                                >
                                  {{ history.createdAt | formatDate }}
                                </div>
                                <div
                                  v-if="history.remarks != ''"
                                  class="newJD-history-subhead mt-1"
                                >
                                  Remarks :
                                </div>
                                <div
                                  v-if="history.remarks != ''"
                                  class="mt-1 newJD-remarks-content"
                                >
                                  {{ history.remarks }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
              <div
                v-if="tabIndex === 1"
                class="d-flex align-items-center adjust-preview-icons"
              >
                <div
                  class="mr-3"
                  v-if="
                    profileInfo.resume != null && !isDocType(profileInfo.resume)
                  "
                >
                  <img
                    @click="downloadFeedback(profileInfo.resume)"
                    class="pointer"
                    src="../../assets/newJD/newCand-download-icon.svg"
                    alt=""
                  />
                </div>
                <div
                  v-if="
                    profileInfo.resume != null && !isDocType(profileInfo.resume)
                  "
                >
                  <img
                    @click="viewResume = true"
                    class="pointer"
                    src="../../assets/newJD/newCand-previewresume-icon.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              newJD-footer
              d-flex
              align-items-center
              justify-content-between
              w-100
              bluebtn
            "
            v-if="isPending || showBuilderProfile"
          >
            <div
              v-if="showBuilderProfile"
              class="pointer ml-3"
              @click="goToCandidateProfile"
            >
              <img
                src="../../assets/img/accessconnew/blueEye.svg"
                alt="/"
                class="pointer"
              />
              <span class="ml-2 newCand-view-font">
                View Candidate Profile
              </span>
            </div>
            <div
              class="d-flex justify-content-end"
              :class="showBuilderProfile ? '' : 'w-100'"
            >
              <b-button
                v-if="isPending"
                @click="
                  decision = 'reject';
                  openAcceptReject = true;
                "
                class="acs-cancelBtn-modal mr-3"
                >Reject</b-button
              >
              <b-button
                v-if="isPending"
                @click="
                  decision = 'approve';
                  openAcceptReject = true;
                "
                class="acs-addBtn-modal pl-4 pr-4 mr-3"
                >Approve</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
    <AcceptReject
      v-if="openAcceptReject"
      :openAcceptReject="openAcceptReject"
      :decision="decision"
      :title="profileInfo.name"
      :from="'candidate'"
      :jobID="candDetails.jobID"
      :candidateID="candDetails.candidateID"
      @close-accept-reject="closeAcceptReject"
    />

    <viewMultipleFeedbackVue
      v-if="showFeedbackModal"
      :showModal="showFeedbackModal"
      :feedbacks="selecetdFeedbacks"
      :candidateData="profileInfo"
      @closeViewIcon="closeFeedbackModal"
      @download-feedback="downloadFeedbackForm"
    />

    <PreviewFeedback
      v-if="singleFeedbackModal"
      :candidateData="profileInfo"
      :selectedRound="singleFeedbackData.feedBackForm.customFeedback"
      :basicCandInfo="singleBasicInfo"
      :ipmodal="singleFeedbackModal"
      :allData="singleFeedbackData"
      :showScreenshot="true"
      @closeModal="closeSingleFeedbackModal"
    />

    <!-- view resume feedback start from here -->
    <ViewResume
      v-if="viewResume"
      :label="'Resume'"
      :showModal="viewResume"
      :link="profileInfo.resume"
      @close-modal="viewResume = false"
    />
    <!-- view resume feedback ends here -->
  </div>
</template>

<script>
import {
  getPendingCandidateDetails,
  getCandidateJobHistory,
  downloadAnyFile,
} from "../../utils/apiFunctions";
import { mapGetters } from "vuex";
import AcceptReject from "../../controllers/OpsHeadApproval/Modal/AcceptReject.vue";
import { downloadFeedback } from "../../utils/download";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";
import pdf from "vue-pdf";
import viewMultipleFeedbackVue from "../../controllers/JD/modals/viewMultipleFeedback.vue";
import PreviewFeedback from "../InterviewProcess/PreviewFeedback.vue";
import EventBus from "../../utils/eventBus";
import ViewResume from "../../components/modals/viewResume.vue";

export default {
  name: "ViewCandidateStatus",

  data() {
    return {
      // NUMBER
      currentPage: 1,
      numPages: 0,
      perPage: 1,
      tabIndex: 0,

      // STRINGS
      remarks: "",
      decision: "",

      // BOOLEAN
      viewResume: false,
      showFeedbackModal: false,
      singleFeedbackModal: false,
      openAcceptReject: false,

      // OBJECTS
      singleBasicInfo: {},
      singleFeedbackData: {},
      profileInfo: {},

      // ARRAYS
      particularJob: [],
      selecetdFeedbacks: [],
    };
  },
  components: {
    AcceptReject,
    pdf,
    PreviewFeedback,
    viewMultipleFeedbackVue,
    ViewResume,
  },
  filters: {
    formatDate(data) {
      if (!data) return "-";
      let formattedDate = data.slice(0, 10).split("-").reverse().join("-");
      return formattedDate;
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    showBuilderProfile() {
      return (
        this.profileInfo.isBuilderProfileAvailable &&
        this.roles.includes("GET_PROFILE")
      );
    },
  },
  watch: {
    openPreview(newVal) {
      if (newVal) {
        this.tabIndex = 0;
        this.getCandidate();
        this.getJdDetails();
      }
    },
  },
  props: {
    openPreview: Boolean,
    isPending: Boolean,
    candDetails: Object,
    customFieldsArray: Array,
  },
  mounted() {
    this.tabIndex = 0;
    this.addCanvasClass();
  },
  updated() {
    this.addCanvasClass();
  },
  methods: {
    closeAcceptReject(type) {
      this.openAcceptReject = false;
      if (!type) EventBus.$emit("on-close-acceptreject");
    },
    handlePageLoaded(pageNumber) {
      this.currentPage = pageNumber;
      const viewerElement = this.$refs.pdf.$el;
      if (viewerElement) {
        viewerElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    async downloadFile(field) {
      const res = await downloadAnyFile(
        this.profileInfo.customFields.imageMedia
      );
      if (res.status == 200) {
        const link = res.data.data.downloadLink;
        const candidateName = res.data.data.name;

        // Create a dynamic file name based on the candidate's name and email
        const fileName = `${candidateName}_${field.label}.pdf`;

        // Create an anchor element
        const a = document.createElement("a");
        a.href = link;
        a.download = fileName; // Set the dynamically generated file name

        // Trigger a click event on the anchor element
        a.click();
      }
    },
    setUserIcon() {
      this.profileInfo.remarks.forEach((activity) => {
        const name = activity.userName;
        if (name.includes(" ")) {
          const [firstName, lastName] = name.split(" ");
          const firstInitial = firstName[0].toUpperCase();
          const lastInitial = lastName[0].toUpperCase();
          activity.userIcon = firstInitial + lastInitial;
        } else {
          const initials = name.slice(0, 2).toUpperCase();
          activity.userIcon = initials;
        }
      });
    },
    addCanvasClass() {
      // Ensure this runs after the DOM is fully rendered
      this.$nextTick(() => {
        const pdfElement = this.$refs.pdf;
        if (pdfElement) {
          const canvas = pdfElement.$el.querySelector("canvas");
          if (canvas) {
            canvas.classList.add("h-100");
          }
        }
      });
    },
    goToCandidateProfile() {
      this.$router.push({
        name: "PreviewOpsheadCandidateProfile",
        params: {
          email: this.profileInfo.email,
        },
        query: {
          source: "approvecandidate",
          jobID: this.candDetails.jobID,
          candidateID: this.candDetails.candidateID,
          status: this.$route.query.status,
        },
      });
    },

    // Feedback Modal Functions
    openFeedbackForm(round) {
      if (round.feedback.length > 1) {
        this.showFeedbackModal = true;
        this.selecetdFeedbacks = round.feedback;
      } else {
        this.singleFeedbackModal = true;
        this.singleFeedbackData = round.feedback[0];
        this.singleBasicInfo = {};
        this.singleBasicInfo["name"] = this.profileInfo.name;
        this.singleBasicInfo["evalDate"] =
          this.singleFeedbackData.feedBackForm.createdAt;
        this.singleBasicInfo["panel"] =
          this.singleFeedbackData.feedBackForm.panelName;
        this.singleBasicInfo["modeOfInterview"] =
          this.singleFeedbackData.interviewRound.type;
        this.singleBasicInfo["action"] =
          this.singleFeedbackData.feedBackForm.recommendation;
        this.singleBasicInfo["remarks"] =
          this.singleFeedbackData.feedBackForm.recruiterRemarks;
        this.singleBasicInfo["feedback"] =
          this.singleFeedbackData.assessmentResponse;
      }
    },

    closeFeedbackModal() {
      this.showFeedbackModal = false;
    },

    closeSingleFeedbackModal() {
      this.singleFeedbackModal = false;
    },

    downloadFeedbackForm(link) {
      const candidateName = this.profileInfo.name;
      const fileName = `${candidateName}.pdf`;
      const a = document.createElement("a");
      a.href = link;
      a.download = fileName;
      a.click();
    },

    // Custom Field Functions
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.profileInfo);
    },

    isHtmlContent(field) {
      return isHtmlContent(field, this.profileInfo);
    },

    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.profileInfo);
    },

    // Check document type for displaying resume
    isDocType(fileUrl) {
      return fileUrl == null
        ? false
        : fileUrl
            .substring(fileUrl.lastIndexOf("/") + 1)
            .split("?")[0]
            .toLowerCase()
            .endsWith(".doc") ||
            fileUrl
              .substring(fileUrl.lastIndexOf("/") + 1)
              .split("?")[0]
              .toLowerCase()
              .endsWith(".docx");
    },

    getFileName(fileName) {
      if (fileName.length <= 30) {
        return fileName;
      } else {
        return fileName.slice(0, 30) + "...";
      }
    },

    downloadFeedback(url) {
      downloadFeedback(url);
    },

    // GET CANDIDATE DETAIL
    async getCandidate() {
      try {
        let data = {
          jobID: this.candDetails.jobID,
          email: this.candDetails.email,
          candidateID: this.candDetails.candidateID,
        };
        const response = await getPendingCandidateDetails(data);
        if (response.status == 200) {
          this.profileInfo = response.data.data;
          this.setUserIcon();
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // GET CANDIDATE INTERVIEW & ASSESSMENT HISTORY
    async getJdDetails() {
      this.particularJob = [];
      let payload = {
        candidateID: this.candDetails.candidateID,
        jobID: this.candDetails.jobID,
        type: "2",
      };
      const res = await getCandidateJobHistory(payload);
      if (res.status === 200) {
        this.particularJob = res.data.data;
      }
    },
  },
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(100%);
}

.h-100 {
  height: 100% !important;
}

.newJD-resume-overflow {
  height: calc(100vh - 240px);
  /* overflow-x: hidden;
  overflow-y: auto; */
  overflow: hidden;
}

.newJD-allocate-overflow-resume {
  height: calc(100vh - 300px);
  overflow: hidden;
}
</style>
